import React, { useState } from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { List } from "antd";
import TableWithControls from "../common/table-with-controls";
import { getUPCCases, esqUPCCases, UPC_SEARCH_URL } from "../../services/api-upc";
import { toDateString, toSetString, toPatentDetailLink, toUPCDetailLink, toUPCDecisionOrderS3Link } from "../../helpers/converters";

const UPCTable = ({ filter, accessLevel }) => {
  const [queries, setQueries] = useState({ sort: "-filing_date", ...filter });
  const fetcher = q => getUPCCases(q).then(json => ({
    data: json.hits.hits.map(e => e.inner_hits
      ? { ...e._source, fullTextMatches: e.inner_hits["documents"].hits.hits.map(f => ({ ...f._source, highlight: f.highlight ? f.highlight["documents.full_text"] : undefined })) }
      : e._source),
    total: json.hits.total.value,
  }));
  const allCols = [
    {
      dataIndex: "case_number",
      title: "Case",
      width: 150,
      sorter: true,
      render: (val, record) => toUPCDetailLink(val, record.original_url)
    },
    {
      dataIndex: "patent_number",
      title: "Patent",
      width: 150,
      sorter: true,
      render: (val, record) => toPatentDetailLink(record.patent_number)
    },
    {
      dataIndex: "filing_date",
      title: "Filing Date",
      width: 100,
      render: toDateString,
      key: "filing_date",
      sorter: true,
    },
    {
      dataIndex: "proceeding_type",
      title: "Type",
      width: 200,
    },
    {
      dataIndex: "action_application_type",
      title: "Action",
      width: 200,
    },
    {
      dataIndex: "respondent",
      title: "Respondent",
      width: 200,
      render: toSetString,
    },
    {
      dataIndex: "claimant",
      title: "Claimant",
      width: 200,
      render: toSetString,
    },
    {
      dataIndex: "representatives",
      title: "Representatives",
      width: 200,
      render: toSetString,
    },
    {
      dataIndex: "judges",
      title: "Judges",
      width: 200,
      render: toSetString,
    }
  ];
  const expandable = queries["documents.full_text"] ? {
    defaultExpandAllRows: true,
    expandedRowRender: record => (
      <List
        dataSource={record.fullTextMatches}
        itemLayout="vertical"
        renderItem={d => (
          <List.Item>
            {toUPCDecisionOrderS3Link(d.s3_key)}
            {d.highlight ? (
              <List
                dataSource={d.highlight}
                renderItem={text => (
                  <List.Item>
                    <span dangerouslySetInnerHTML={{ __html: text }} />
                  </List.Item>
                )}
                style={{ marginLeft: 25 }}
              />
            ) : null}
          </List.Item>
        )}
        size="small"
      />
    )
  } : undefined;
  const helmet = {
    title: "UPC Case List",
    meta: [
      {
        name: "description",
        content: "Searchable list of all UPC cases",
      },
    ],
  };
  return (
    <>
      <Helmet {...helmet} />
      <TableWithControls
        queries={queries}
        fetcher={fetcher}
        onChange={setQueries}
        columns={allCols}
        columnKeysSelected={["case_number", "patent_number", "filing_date", "action_application_type", "respondent", "claimant"]}
        rowKey="case_number"
        tableKey="upcTable"
        expandable={expandable}
        shouldExport={accessLevel === "full"}
        exportESUrl={UPC_SEARCH_URL}
        exportESQueryBuilder={esqUPCCases}
      />
    </>
  )
};

UPCTable.propTypes = {
  filter: PropTypes.object,
  accessLevel: PropTypes.string,
};

export default UPCTable;